export default {
      id: "arrow-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#arrow",
      toString: function () {
        return this.url;
      }
    }